import React from 'react';
import { useTranslation } from 'react-i18next';
import { hasAnalyticsConsent, setAnalyticsConsent } from '../utils/analytics';
/**
 * Consent banner that gates GA4 initialization and event dispatch.
 * Renders fixed to the bottom of the viewport until a decision is made.
 */
export default function ConsentBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    // Show the banner only when no decision has been recorded yet.
    try {
      if (window.localStorage.getItem('analytics-consent') === null) {
        setVisible(true);
      }
    } catch {
      // Storage unavailable: fail closed and keep GA4 disabled.
    }
  }, []);

  if (!visible) return null;

  const decide = (granted) => {
    setAnalyticsConsent(granted);
    setVisible(false);
  };

  return (
    <div
      role="region"
      aria-label={t('consent.regionAria')}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '12px 16px',
        backgroundColor: '#fff',
        borderTop: '1px solid #ccc',
      }}
    >
      <p style={{ margin: 0, fontSize: '0.9rem' }}>
        {t('consent.text')}
      </p>
      <button type="button" onClick={() => decide(true)}>{t('consent.accept')}</button>
      <button type="button" onClick={() => decide(false)}>{t('consent.decline')}</button>
    </div>
  );
}
